__turbopack_context__.v({
  "emptyStar": "styles-module__AftZyq__emptyStar",
  "filledStar": "styles-module__AftZyq__filledStar",
  "starsRow": "styles-module__AftZyq__starsRow",
});
